module.exports = {
      id: "new-label-usage",
      viewBox: "0 0 26 10",
      url: __webpack_public_path__ + "svg-sprite-f2ca7f9d4080f6eed262da64a41d98e9.svg#new-label",
      toString: function () {
        return this.url;
      }
    }